import { useCallback, useEffect, useState } from 'react';

import { VendorTaxonomyKey } from '@zola-helpers/client/dist/es/marketplace';

import { setUserSetting } from '~/actions/couples/userSettingsActions';
import { useUrlPathChanged } from '~/hooks/useUrlPathChanged';
import { useAppDispatch } from '~/reducers';
import { vendorTypeKeyToUserSettingsKey } from '~/reducers/couples/userSettingsReducer';

export const useDismissTopPicks = ({
  taxonomyKey,
}: {
  taxonomyKey: VendorTaxonomyKey | undefined;
}) => {
  const dispatch = useAppDispatch();
  const path = useUrlPathChanged();
  const [previousPath, setPreviousPath] = useState(path);

  const dispatchSawTopPicksSetting = useCallback(() => {
    if (taxonomyKey) {
      const userSettingForCategory = vendorTypeKeyToUserSettingsKey(taxonomyKey);
      dispatch(setUserSetting(userSettingForCategory)).catch(() => null);
    }
  }, [dispatch, taxonomyKey]);

  useEffect(() => {
    if (previousPath !== path) {
      setPreviousPath(path);
      if (previousPath) dispatchSawTopPicksSetting();
    }
  }, [path, previousPath, dispatchSawTopPicksSetting]);
};
